import { api } from 'api'
import { toaster } from 'uikit/Toaster'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useImportFaq = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      // Запрашиваем файл у пользователя
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.txt' // Укажите нужные форматы файлов

      return new Promise((resolve, reject) => {
        input.oncancel = () => {
          reject(new Error('Выбор файла отменен'))
        }

        input.onchange = (event: any) => {
          const file = event.target.files[0]

          // Создаем FormData объект для multipart/form-data
          const formData = new FormData()
          formData.append('file', file)

          // Вызываем API с FormData
          resolve(api.faq.import(formData))
        }

        input.click()
      })
    },
    onError: (err: any) => {
      toaster.create({
        type: 'warning',
        title: 'Произошла ошибка при загрузке файла',
        description: err.message,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['faqList'] })
      toaster.create({
        type: 'success',
        title: 'Файл успешно загружен',
      })
    },
    gcTime: 0,
  })
}
